import React from "react";
import cx from "classnames";
import { dataTestIds } from "data-testids";

import { CrossThickIcon } from "assets";
import "./FilterTag.scss";

export interface IFilterTagProps {
  /** The text for the link */
  text: string;
  /** Handler for interacting with the button via click, Enter or Spacebar keys */
  onClick?: (event?: React.MouseEvent<HTMLDivElement>) => void;
  /** Optional id for the link */
  id?: string;
  /** Optional className to provide spacing between components */
  className?: string;
}

export const FilterTag: React.FC<React.PropsWithChildren<IFilterTagProps>> = ({
  text,
  onClick,
  id,
  className,
}) => {
  return (
    <div
      data-testid={dataTestIds.componentLibrary["Atoms.FilterTag.filterTag"]}
      tabIndex={0}
      className={cx("c-filter-tag flex items-center gap-2", className)}
      onClick={onClick}
      id={id}
    >
      <span className="c-filter-tag__text">{text}</span>
      <CrossThickIcon width={16} height={16} />
    </div>
  );
};
